const initialState = {
  operators: [],
  cityOperators: [],
  selectedOperator: [],
};
export default initialState;
